import { render, staticRenderFns } from "./index--device--only.vue?vue&type=template&id=7918795a&scoped=true&"
import script from "./index--device--only.vue?vue&type=script&lang=js&"
export * from "./index--device--only.vue?vue&type=script&lang=js&"
import style0 from "./index--device--only.vue?vue&type=style&index=0&id=7918795a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7918795a",
  null
  
)

export default component.exports